import React from "react";
import Modal from "react-bootstrap/Modal";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import IconEmail from "../../atoms/Icons/IconEmail";
import SocialMediaIcons from "../../molecules/Icons/SocialMediaIcons";

const PeopleModal = ({detail, setDetail}) => {
  return (
    <Modal
      backdropClassName="dept-people-modal-backdrop"
      className="dept-people-modal"
      scrollable
      size="xl"
      fullscreen="sm-down"
      centered
      show={detail?.open}
      onHide={() => setDetail({ ...detail, open: false })}
    >
      <Modal.Header closeButton className="dept-people-modal-header">
        <div className="dept-people-modal-header-inner">
          <div>
            {detail?.data?.relationships?.field_department_people_icon ? (
              <>
                <GatsbyImage
                  className="dept-people-modal-img"
                  image={getImage(
                    detail?.data?.relationships?.field_department_people_icon
                      ?.gatsbyImage
                  )}
                  alt={detail?.data?.field_department_people_name}
                />
              </>
            ) : (
              <div className="dept-image-wrapper-default bg-clr-lightgrey dept-people-modal-img">
                <img src="/images/avatar.png" alt="avatar" />
              </div>
            )}
          </div>
          <div className="dept-people-modal-header-right">
            <h2 data-aos="underlined" className="dept-people-modal-title underlined">
              {detail?.data?.field_department_people_name}
            </h2>
            <h4 className="dept-people-modal-subtitle">
              {detail?.data?.field_department_people_title}
            </h4>
            <div className="dept-people-modal-social-icons-wrap">
              <div className="dept-people-modal-social-icons">
                {detail?.data?.field_department_people_email && (
                  <a
                    aria-label="email"
                    rel="noopener noreferrer"
                    className="dept-people-modal-social-icons"
                    href={`mailto:${detail?.data?.field_department_people_email}`}
                    target="_blank"
                  >
                    <IconEmail color="secondary" />
                  </a>
                )}
                <SocialMediaIcons
                  color="secondary"
                  variant="dept-people-modal-social-icons"
                  platformValues={
                    detail?.data?.field_social_profile_links?.platform_values
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="dept-people-modal-body">
        <div
          dangerouslySetInnerHTML={{
            __html: detail?.data?.field_people_read_more_expand?.processed,
          }}
        />
      </Modal.Body>
    </Modal>
  )
}

export default PeopleModal;